export function slugify(text) {
  const translitMap = {
    // Armenian
    Ա: "a", Բ: "b", Գ: "g", Դ: "d", Ե: "e", Զ: "z", Է: "e", Ը: "y", Թ: "t",
    Ժ: "zh", Ի: "i", Լ: "l", Խ: "kh", Ծ: "ts", Կ: "k", Հ: "h", Ձ: "dz", Ղ: "gh",
    Ճ: "ch", Մ: "m", Յ: "y", Ն: "n", Շ: "sh", Ո: "o", Չ: "ch", Պ: "p", Ջ: "j",
    Ռ: "r", Ս: "s", Վ: "v", Տ: "t", Ր: "r", Ց: "ts", Ւ: "v", Փ: "p", Ք: "q",
    Օ: "o", Ֆ: "f",
    ա: "a", բ: "b", գ: "g", դ: "d", ե: "e", զ: "z", է: "e", ը: "y", թ: "t",
    ժ: "zh", ի: "i", լ: "l", խ: "kh", ծ: "ts", կ: "k", հ: "h", ձ: "dz", ղ: "gh",
    ճ: "ch", մ: "m", յ: "y", ն: "n", շ: "sh", ո: "o", չ: "ch", պ: "p", ջ: "j",
    ռ: "r", ս: "s", վ: "v", տ: "t", ր: "r", ց: "ts", ւ: "v", փ: "p", ք: "q",
    օ: "o", ֆ: "f",
    // Russian
    А: "a", Б: "b", В: "v", Г: "g", Д: "d", Е: "e", Ё: "yo", Ж: "zh", З: "z",
    И: "i", Й: "y", К: "k", Л: "l", М: "m", Н: "n", О: "o", П: "p", Р: "r",
    С: "s", Т: "t", У: "u", Ф: "f", Х: "kh", Ц: "ts", Ч: "ch", Ш: "sh", Щ: "sch",
    Ъ: "", Ы: "y", Ь: "", Э: "e", Ю: "yu", Я: "ya",
    а: "a", б: "b", в: "v", г: "g", д: "d", е: "e", ё: "yo", ж: "zh", з: "z",
    и: "i", й: "y", к: "k", л: "l", м: "m", н: "n", о: "o", п: "p", р: "r",
    с: "s", т: "t", у: "u", ф: "f", х: "kh", ц: "ts", ч: "ch", ш: "sh", щ: "sch",
    ъ: "", ы: "y", ь: "", э: "e", ю: "yu", я: "ya",
  };

  return text
    .toString()
    .split("")
    .map((ch) => translitMap[ch] || ch)
    .join("")
    .normalize("NFKD")
    .replace(/\s+/g, "-")
    .replace(/[^\p{L}\p{N}-]+/gu, "")
    .replace(/--+/g, "-")
    .toLowerCase()
    .trim();
}
